const CLIENT_SEARCH = 1;
const CLIENT_NOTES_SEARCH = 4;
const TRACKING_HISTORY_SEARCH = 5;

export {
    CLIENT_SEARCH,
    CLIENT_NOTES_SEARCH,
    TRACKING_HISTORY_SEARCH
}